
import { Vue, Component } from 'vue-property-decorator';
import EmailInput from '@/components/inputs/EmailInput.vue';

import userx from '@/store/modules/userx';
import { Route, RawLocation } from 'vue-router';
import router from '@/router';
import progressToastx from '@/store/modules/progressToastx';

@Component({
	components: {
		EmailInput,
	},
})
export default class SetSupportLvl extends Vue {
	public email: string = '';
	public validateEmailNow = false;

	public supportLvl = 0;
	public options = [
		{ value: 0, text: 'lvl 0: Not support'},
		{ value: 1, text: 'lvl 1: Can view accounts & sync now'},
		{ value: 2, text: 'lvl 2: Can purge sync, download synced data'},
		{ value: 3, text: 'lvl 3: Can manage accounts, expire/enable token, add/remove users'},
		{ value: 10, text: 'lvl 10: Set support level'},
	];

	public async setSupportLvl() {
		this.validateEmailNow = true;
		if (this.email !== undefined) {
			const email = this.email;
			const supportLvl = this.supportLvl;
			this.validateEmailNow = false;
			this.email = '';

			const toastId = await progressToastx.add({title: `${email}`,
												state: `Appointing as Level ${supportLvl} Support...`,
												variant: 'info',
												});

			const result = await userx.setSupportLvl({email, supportLvl});
			if (result.success) {
				progressToastx.done({id: toastId, state: `Appointed as Level ${supportLvl} Support!`});
			} else {
				progressToastx.error({id: toastId, state: result.errorMessage});
			}
		}
	}
}
